document.addEventListener("DOMContentLoaded", function () {
  const totalAreaRadio = document.getElementById("total-area");
  const widthLengthRadio = document.getElementById("Width-Length");

  const areaInputContainer = document.querySelector(".input-container-area");
  const lengthWidthInputsContainer = document.querySelector(".length-width-inputs");

  function toggleInputFields() {
    if (totalAreaRadio.checked) {
      areaInputContainer.style.display = "block";
      lengthWidthInputsContainer.style.display = "none";
    } else {
      areaInputContainer.style.display = "none";
      lengthWidthInputsContainer.style.display = "flex";
    }
  }

  toggleInputFields();

  totalAreaRadio.addEventListener("change", toggleInputFields);
  widthLengthRadio.addEventListener("change", toggleInputFields);

  let currentUnit = "meters";

  function convertToMeters(value, unit, isArea = false) {
    if (isNaN(value)) return 0;
    const conversions = {
      feet: isArea ? value / 10.764 : value / 3.281,
    };
    return conversions[unit] !== undefined ? conversions[unit] : value;
  }

  function updateLabels() {
    const unitLabels = {
      meters: { width: "(m)", length: "(m)", area: "(m²)" },
      feet: { width: "(ft)", length: "(ft)", area: "(ft²)" },
    };
    const labels = unitLabels[currentUnit];
    document.querySelector("label[for='calculator-width']").innerHTML = labels.width;
    document.querySelector("label[for='calculator-length']").innerHTML = labels.length;
    document.querySelector("label[for='calculator-area']").innerHTML = labels.area;
  }

  window.updateCustomPriceDisplay = function (totalPrice) {
    if (typeof totalPrice !== "number" || isNaN(totalPrice)) return;
    const priceDisplay = document.getElementById("total-price-display");
    const btnPriceDisplay = document.getElementById("button-dynamic-pricing");
    const displayPrice = totalPrice;
    if (priceDisplay) {
      priceDisplay.innerHTML = `£${displayPrice.toFixed(2)}`;
    }
    if (btnPriceDisplay) {
      btnPriceDisplay.innerHTML = `£${displayPrice.toFixed(2)}`;
    }
  };

  // Function to update price based on quantity selector
  function updatePriceFromQuantitySelector() {
    try {
      const calculatorDiv = document.querySelector(".calculator-div");
      if (!calculatorDiv) return;

      const sectionId = calculatorDiv.getAttribute("data-section-id");
      const quantityPicker = document.querySelector(`.price-per-item__container #Quantity-${sectionId}`);
      
      if (quantityPicker) {
        const quantity = parseInt(quantityPicker.value) || 0;
        const perPackPrice = parseFloat(calculatorDiv.getAttribute('data-per-pack-price')) || 0;
        const totalPrice = quantity * perPackPrice;

        // Update the line item property for Total_Packs (both forms)
        const totalPacksTally = document.getElementById("totalPacksTally");
        const totalPacksTallyCalculator = document.getElementById("totalPacksTally-calculator");
        
        if (totalPacksTally) {
          totalPacksTally.setAttribute('value', quantity);
        }
        if (totalPacksTallyCalculator) {
          totalPacksTallyCalculator.setAttribute('value', quantity);
        }

        // Update the Total Packs and m² display fields
        const qtyRequired = document.getElementById("qty-required");
        const areaRequiredValue = document.getElementById("area-required-value");
        const coverage = parseFloat(calculatorDiv.getAttribute("data-metafield-coverage")) || 1;

        if (qtyRequired) {
          qtyRequired.innerHTML = `Total Packs: ${quantity}`;
        }
        if (areaRequiredValue) {
          const totalArea = (quantity * coverage).toFixed(2);
          areaRequiredValue.innerHTML = totalArea;
        }

        window.latestTotalPrice = totalPrice;
        updateCustomPriceDisplay(totalPrice);
      }
    } catch (error) {
      console.warn('Error updating price from quantity selector:', error);
    }
  }

  // Function to update quantity selector from calculator
  function updateQuantitySelector(quantity) {
    const calculatorDiv = document.querySelector(".calculator-div");
    if (!calculatorDiv) return;

    const sectionId = calculatorDiv.getAttribute("data-section-id");
    const quantityPicker = document.querySelector(`.price-per-item__container #Quantity-${sectionId}`);
    
    if (quantityPicker) {
      quantityPicker.value = quantity;
      quantityPicker.setAttribute("value", quantity);
      // Trigger any quantity-related events
      quantityPicker.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function calculateQuantityLengthWidth() {
    const width = parseFloat(document.getElementById("calculator-width").value);
    const length = parseFloat(document.getElementById("calculator-length").value);
    const addWastage = document.getElementById("add-wastage").checked;

    if (isNaN(width) || isNaN(length)) {
      document.getElementById("qty-required").innerHTML = "Qty Required: 0";
      document.getElementById("area-required-value").innerHTML = "0";
      updateQuantitySelector(0);
      return;
    }

    const coverage = parseFloat(document.querySelector(".calculator-div").getAttribute("data-metafield-coverage"));
    let convertedWidth = convertToMeters(width, currentUnit);
    let convertedLength = convertToMeters(length, currentUnit);
    let output = convertedWidth * convertedLength;
    if (addWastage) output *= 1.05;

    let areaOutput = output.toFixed(2);
    output = Math.ceil(output / coverage);

    document.getElementById("qty-required").innerHTML = "Qty Required: " + output + " packs";
    document.getElementById("area-required-value").innerHTML = areaOutput;

    updateQuantitySelector(output);

    const perPackPrice = parseFloat(document.querySelector('.calculator-div').getAttribute('data-per-pack-price')) || 0;
    const totalPrice = output * perPackPrice;

    // Update the line item property for Total_Packs (both forms)
    const totalPacksTally = document.getElementById("totalPacksTally");
    const totalPacksTallyCalculator = document.getElementById("totalPacksTally-calculator");
    
    if (totalPacksTally) {
      totalPacksTally.setAttribute('value', output);
    }
    if (totalPacksTallyCalculator) {
      totalPacksTallyCalculator.setAttribute('value', output);
    }

    window.latestTotalPrice = totalPrice;
    updateCustomPriceDisplay(totalPrice);
  }

  function calculateQuantityArea() {
    const area = parseFloat(document.getElementById("calculator-area").value);
    const addWastage = document.getElementById("add-wastage").checked;

    if (isNaN(area)) {
      document.getElementById("qty-required").innerHTML = "Total Packs: 0";
      document.getElementById("area-required-value").innerHTML = "0";
      updateQuantitySelector(0);
      return;
    }

    const coverage = parseFloat(document.querySelector(".calculator-div").getAttribute("data-metafield-coverage"));
    let output = convertToMeters(area, currentUnit, true);
    if (addWastage) output *= 1.05;

    let areaOutput = output.toFixed(2);
    output = Math.ceil(output / coverage);

    document.getElementById("qty-required").innerHTML = "Total Packs: " + output;
    document.getElementById("area-required-value").innerHTML = areaOutput;

    updateQuantitySelector(output);

    const perPackPrice = parseFloat(document.querySelector('.calculator-div').getAttribute('data-per-pack-price')) || 0;
    const totalPrice = output * perPackPrice;

    const addProperty = document.getElementById("totalPacksTally");
    const addPropertyCalculator = document.getElementById("totalPacksTally-calculator");
    if (addProperty) {
      addProperty.setAttribute('value', output);
    }
    if (addPropertyCalculator) {
      addPropertyCalculator.setAttribute('value', output);
    }

    window.latestTotalPrice = totalPrice;
    updateCustomPriceDisplay(totalPrice);
  }

  function wastage() {
    const width = parseFloat(document.getElementById("calculator-width").value);
    const length = parseFloat(document.getElementById("calculator-length").value);
    const area = parseFloat(document.getElementById("calculator-area").value);

    if (!isNaN(width) || !isNaN(length)) {
      document.getElementById("calculator-area").value = "";
      calculateQuantityLengthWidth();
    } else if (!isNaN(area)) {
      document.getElementById("calculator-width").value = "";
      document.getElementById("calculator-length").value = "";
      calculateQuantityArea();
    } else {
      document.getElementById("qty-required").innerHTML = "Total Packs: 0";
      document.getElementById("area-required-value").innerHTML = "0";
    }
  }

  function wastageLengthWidth() {
    const width = parseFloat(document.getElementById("calculator-width").value);
    const length = parseFloat(document.getElementById("calculator-length").value);
    if (!isNaN(width) || !isNaN(length)) {
      document.getElementById("calculator-area").value = "";
      calculateQuantityLengthWidth();
    } else {
      document.getElementById("qty-required").innerHTML = "Total Packs: 0";
      document.getElementById("area-required-value").innerHTML = "0";
    }
  }

  function wastageArea() {
    const area = parseFloat(document.getElementById("calculator-area").value);
    if (!isNaN(area)) {
      document.getElementById("calculator-width").value = "";
      document.getElementById("calculator-length").value = "";
      calculateQuantityArea();
    }
  }

  const unitRadios = document.querySelectorAll('input[name="measurement-unit"]');

  function updateUnit() {
    const selectedUnit = document.querySelector("input[name='measurement-unit']:checked");
    if (selectedUnit) {
      currentUnit = selectedUnit.value;
      updateLabels();
      wastage();
    }
  }

  unitRadios.forEach((radio) => {
    radio.addEventListener("change", updateUnit);
  });

  updateUnit();

  document.getElementById("calculator-width").addEventListener("input", wastageLengthWidth);
  document.getElementById("calculator-length").addEventListener("input", wastageLengthWidth);
  document.getElementById("calculator-area").addEventListener("input", wastageArea);
  document.getElementById("add-wastage").addEventListener("change", wastage);

  // Add event listeners for quantity selector
  function setupQuantitySelectorListeners() {
    const calculatorDiv = document.querySelector(".calculator-div");
    if (!calculatorDiv) return;

    const sectionId = calculatorDiv.getAttribute("data-section-id");
    const quantityPicker = document.querySelector(`.price-per-item__container #Quantity-${sectionId}`);
    
    if (quantityPicker) {
      // Listen for direct input changes
      quantityPicker.addEventListener("input", updatePriceFromQuantitySelector);
      quantityPicker.addEventListener("change", updatePriceFromQuantitySelector);
      
      // Don't add duplicate click listeners to plus/minus buttons
      // The QuantityInput class already handles these
      // Instead, listen for the change event that gets dispatched
    }
  }

  // Setup quantity selector listeners on load
  setupQuantitySelectorListeners();

  // Optimized MutationObserver with error handling
  let observer = null;
  try {
    observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Debounce the setup to prevent excessive calls
          clearTimeout(window.quantitySetupTimeout);
          window.quantitySetupTimeout = setTimeout(setupQuantitySelectorListeners, 100);
        }
      });
    });

    // Observe the calculator div for changes
    const calculatorDiv = document.querySelector(".calculator-div");
    if (calculatorDiv) {
      observer.observe(calculatorDiv, { childList: true, subtree: true });
    }
  } catch (error) {
    console.warn('MutationObserver setup failed:', error);
  }

  // Function to reset price display after cart update
  function resetPriceDisplay() {
    // Check which tab is currently active
    const calculatorHeaderButton = document.getElementById('calculator-header-button');
    const packsHeaderButton = document.getElementById('packs-header-button');
    const isCalculatorTabActive = calculatorHeaderButton?.classList.contains('active');
    const isPacksTabActive = packsHeaderButton?.classList.contains('active');

    // If packs tab is active, don't reset quantity and price
    if (isPacksTabActive) {
      // Only reset calculator fields, keep quantity selector and price
      const areaInput = document.getElementById("calculator-area");
      const widthInput = document.getElementById("calculator-width");
      const lengthInput = document.getElementById("calculator-length");
      const wastageCheckbox = document.getElementById("add-wastage");
      const qtyRequired = document.getElementById("qty-required");
      const areaRequiredValue = document.getElementById("area-required-value");

      // Reset only calculator input fields
      if (areaInput) {
        areaInput.value = "";
      }
      if (widthInput) {
        widthInput.value = "";
      }
      if (lengthInput) {
        lengthInput.value = "";
      }
      if (wastageCheckbox) {
        wastageCheckbox.checked = false;
      }

      // Reset only calculator display fields
      if (qtyRequired) {
        qtyRequired.innerHTML = "Total Packs: 0";
      }
      if (areaRequiredValue) {
        areaRequiredValue.innerHTML = "0";
      }

      // Reset price to price of 1 item
      const calculatorDiv = document.querySelector(".calculator-div");
      if (calculatorDiv) {
        const perPackPrice = parseFloat(calculatorDiv.getAttribute('data-per-pack-price')) || 0;
        const priceDisplay = document.getElementById("total-price-display");
        const btnPriceDisplay = document.getElementById("button-dynamic-pricing");
        
        if (priceDisplay) {
          priceDisplay.innerHTML = `£${perPackPrice.toFixed(2)}`;
        }
        if (btnPriceDisplay) {
          btnPriceDisplay.innerHTML = `£${perPackPrice.toFixed(2)}`;
        }
        
        // Update the latest total price to price of 1 item
        window.latestTotalPrice = perPackPrice;
      }

      // Keep quantity selector as it is
      return;
    }

    // If calculator tab is active, reset everything
    const priceDisplay = document.getElementById("total-price-display");
    const btnPriceDisplay = document.getElementById("button-dynamic-pricing");
    
    if (priceDisplay) {
      priceDisplay.innerHTML = "£0.00";
    }
    if (btnPriceDisplay) {
      btnPriceDisplay.innerHTML = "£0.00";
    }
    
    // Reset the latest total price
    window.latestTotalPrice = 0;

    // Reset all calculation fields
    const areaInput = document.getElementById("calculator-area");
    const widthInput = document.getElementById("calculator-width");
    const lengthInput = document.getElementById("calculator-length");
    const wastageCheckbox = document.getElementById("add-wastage");
    const qtyRequired = document.getElementById("qty-required");
    const areaRequiredValue = document.getElementById("area-required-value");

    // Reset input fields
    if (areaInput) {
      areaInput.value = "";
    }
    if (widthInput) {
      widthInput.value = "";
    }
    if (lengthInput) {
      lengthInput.value = "";
    }
    if (wastageCheckbox) {
      wastageCheckbox.checked = false;
    }

    // Reset display fields
    if (qtyRequired) {
      qtyRequired.innerHTML = "Total Packs: 0";
    }
    if (areaRequiredValue) {
      areaRequiredValue.innerHTML = "0";
    }

    // Reset quantity selector to default (1)
    const calculatorDiv = document.querySelector(".calculator-div");
    if (calculatorDiv) {
      const sectionId = calculatorDiv.getAttribute("data-section-id");
      const quantityPicker = document.querySelector(`.price-per-item__container #Quantity-${sectionId}`);
      if (quantityPicker) {
        quantityPicker.value = 1;
        quantityPicker.setAttribute("value", 1);
      }
    }

    // Reset line item properties
    const totalPacksTally = document.getElementById("totalPacksTally");
    const totalPacksTallyCalculator = document.getElementById("totalPacksTally-calculator");
    
    if (totalPacksTally) {
      totalPacksTally.setAttribute('value', 1);
    }
    if (totalPacksTallyCalculator) {
      totalPacksTallyCalculator.setAttribute('value', 1);
    }
  }

  // Listen for cart update events to reset price
  document.addEventListener('cart:updated', resetPriceDisplay);
  document.addEventListener('cart:refresh', resetPriceDisplay);

  // Also listen for form submission to reset price
  function setupAddToCartListeners() {
    const addToCartButtons = document.querySelectorAll('[id^="ProductSubmitButton-"]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Reset price after a short delay to allow cart update
        setTimeout(resetPriceDisplay, 1000);
      });
    });
  }

  // Setup add to cart listeners on load
  setupAddToCartListeners();

  // Optimized cart observer with error handling
  let cartObserver = null;
  try {
    cartObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Debounce the setup to prevent excessive calls
          clearTimeout(window.cartSetupTimeout);
          window.cartSetupTimeout = setTimeout(setupAddToCartListeners, 100);
        }
      });
    });

    // Observe the document body for changes (more targeted)
    cartObserver.observe(document.body, { childList: true, subtree: false });
  } catch (error) {
    console.warn('Cart MutationObserver setup failed:', error);
  }

  // Cleanup function for observers
  function cleanup() {
    if (observer) {
      observer.disconnect();
    }
    if (cartObserver) {
      cartObserver.disconnect();
    }
    clearTimeout(window.quantitySetupTimeout);
    clearTimeout(window.cartSetupTimeout);
  }

  // Cleanup on page unload
  window.addEventListener('beforeunload', cleanup);

  updateLabels();
});
